import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'
import LoginPage from './components/LoginPage.vue'
import HomePage from './views/HomePage.vue'
import KolClipper from './components/KolClipper.vue'
import ParaClipper from './components/sub/ParaClipper.vue'
import WordClipper from './components/sub/WordClipper.vue'
import SelectVideo from './components/sub/SelectVideo.vue'
import LiveRecords from './components/LiveRecords.vue'
import AppVue from './App.vue'
import UploadVideo from './components/sub/UploadVideo.vue'
import UploadClipper from './components/UploadClipper.vue'
import SearchPage from './components/SearchPage.vue'
import MultiClipperLayout from './components/multi_clipper/MultiClipperLayout.vue'
import ClothingTimelineLayout from './components/clothing_timeline/ClothingTimelineLayout.vue'


const routes =  [
        {
            path: '/',
            component: HomePage
        },
        
        {
            path: '/login',
            component: LoginPage
        },
        {
            path: '/clipper/clothing-timeline',
            component: ClothingTimelineLayout
        },
        {
            path: '/clipper',
            component: HomePage,
            children: [
                // {
                //     path: '',
                //     redirect: '/clipper/kol/'
                // },
                {
                    path: 'kol/',
                    component: KolClipper,
                    children: [
                        {
                            path: 'para',
                            component: ParaClipper
                        },
                        {
                            path: 'word',
                            component: WordClipper
                        },
                        {
                            path: 'select',
                            component: SelectVideo
                        },
                        {
                            path:'',
                            component: SelectVideo
                        }
                    ]
                },
                {
                    path:'live',
                    component:LiveRecords,                    
                },
                {
                    path: 'search',
                    component: SearchPage,
                },
                {
                    path: 'upload',
                    component: UploadClipper
                },
                {
                    path: 'multi',
                    component: MultiClipperLayout
                }
            ]
        }
    ]
    
const router = createRouter({
    // history: createWebHistory(process.env.BASE_URL),
    history: createWebHashHistory(),
    routes
})


router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token')

    // VIP Validation Logic
    let isVip = false;
    const userStr = localStorage.getItem('user');
    if (userStr) {
        try {
            const user = JSON.parse(userStr);
            const vipInfo = user.vip_info || {};
            const vipType = vipInfo.vip_type || 'none';
            const expireTime = vipInfo.expire_time;
            if (vipType !== 'none') {
                 if (expireTime) {
                     const expire = new Date(expireTime);
                     if (expire > new Date()) {
                         isVip = true;
                     }
                 }
            }
        } catch (e) {
            console.error('VIP validation error', e);
        }
    }

    if(to.path === '/login'){
        if(token && isVip){
            next('/clipper/')
        }else{
            next()
        }
    }else{
        if(token){
            if (isVip) {
                next()
            } else {
                next('/login')
            }
        }else{
            next('/login')
        }        
    }
})

export default router